import { EMOIJS_DATA } from './face'
import EmotionsChar from './EmotionsChar.json'

const comment = require('./comment.png')
const emoij = require('./emoij.png')
const logo = require('./logo.png')
const photo_orange = require('./photo_orange.png')
const photo_blue = require('./photo_blue.png')
const zan_unselect = require('./zan_unselect.png')
const zan_select = require('./zan_select.png')
const video = require('./video.png')
const close = require('./close.png')
const add = require('./add.png')
const close_white = require('./close_white.png')
const avatar_bg = require('./avatar_bg.png')
const brand_icon = require('./brand_icon.png')
const bg = require('./bg.png')
const title = require('./title.png')
const video_play = require('./play.png')
const profile__title = require('./profile__title.png')
const profile__user_bg = require('./profile__user_bg.png')
const profile__icon1 = require('./profile__icon1.png')
const profile__icon2 = require('./profile__icon2.png')
const profile__icon3 = require('./profile__icon3.png')
const work__like_select = require('./work__like_select.png')
const work__like_unselect = require('./work__like_unselect.png')
const back = require('./back.png')
const delete_icon = require('./delete.png')
const message_icon = require('./message.png')
const flower = require('./flower.png')
const flower_select = require('./flower_select.png')
const flower_unselect = require('./flower_unselect.png')
const work_icon = require('./work_icon.png')
const oj_icon = require('./oj_icon.png')
const friend_icon = require('./friend_icon.png')
const medal_gold = require('./medal_gold.png')
const medal_silver = require('./medal_silver.png')
const medal_bronze = require('./medal_bronze.png')
const arrow_left = require('./arrow_left.png')
const arrow_right = require('./arrow_right.png')
const back_top = require('./back_top.png')
const lock_icon = require('./lock_icon.png')
const company_icon = require('./company_icon.png')
const rank_bg = require('./rank_bg.png')
const tip_arrow_top = require('./tip_arrow_top.png')
const company_ceo_icon = require('./company_ceo.png')
const company_income_icon = require('./company_income.png')
const company_member_icon = require('./company_member.png')
const company_product_icon = require('./company_product.png')
const company_update_icon = require('./company_update.png')
const more_left_arrow = require('./more_left.png')
const more_right_arrow = require('./more_right.png')
const invite_icon = require("./invite.png")
const question_add = require("./question/add.png")
const question_photo = require("./question/photo.png")
const question_select = require("./question/select.png")
const question_sub = require("./question/sub.png")
const question_unselect = require("./question/unselect.png")
const question_wrong = require("./question/wrong.png")
const question_alert = require("./question/alert.png")
const question_close = require("./question/close.png")
const ad = require("./ad1.png")
const search = require("./search.png")
const eye = require("./eye.png")
const scratch_icon = require("./scratch_icon.png")
const left_arrow_orange = require('./arrow_left_orange.png')
const right_arrow_orange = require('./arrow_right_orange.png')
const user_guide_arrow = require('./user_guide_arrow.png')
const default_avatar = require('./default_avatar.png')
const scratch_all_works = require('./scratch_all_works.svg')
const lock_schedule = require('./lock_schedule.png')
const activity_signup = require("./activity/signup.png")
const activity_logo = require("./activity/logo.png")
const disney_activity = require("./disney_activity.png")


export {
  /** 原有的表情字符 */
  EmotionsChar as EMOTIONS_CHAR,
  /** gif 表情图片 */
  EMOIJS_DATA,
  comment as IMG_COMMENT,
  emoij as IMG_EMOIJ,
  logo as IMG_LOGO,
  photo_orange as IMG_PHOTO_ORANGE,
  photo_blue as IMG_PHOTO_BLUE,
  zan_unselect as IMG_ZAN_UNSELECT,
  zan_select as IMG_ZAN_SELECT,
  video as IMG_VIDEO,
  close as IMG_CLOSE,
  add as IMG_ADD,
  close_white as IMG_CLOSE_WHITE,
  avatar_bg as AVATAR_BG,
  brand_icon as BRAND_ICON,
  bg as BG,
  title as TITLE,
  video_play as VIDEO_PLAY,
  profile__title as IMG_PROFILE__TITLE,
  profile__user_bg as IMG_PROFILE__USER_BG,
  profile__icon1 as IMG_PROFILE_ICON_1,
  profile__icon2 as IMG_PROFILE_ICON_2,
  profile__icon3 as IMG_PROFILE_ICON_3,
  work__like_select as IMG_WORK__LIKE_SELECT,
  work__like_unselect as IMG_WORK__LIKE_UNSELECT,
  back as IMG_BACK,
  delete_icon as IMG_DELETE_ICON,
  message_icon as IMG_MESSAGE_ICON,
  flower as IMG_FLOWER,
  flower_select as IMG_FLOWER_SELECT,
  flower_unselect as IMG_FLOWER_UNSELECT,
  work_icon as IMG_WORK_ICON,
  friend_icon as IMG_FRIEND_ICON,
  oj_icon as IMG_OJ_ICON,
  medal_gold as IMG_MEDAL_GOLD,
  medal_silver as IMG_MEDAL_SILVER,
  medal_bronze as IMG_MEDAL_BRONZE,
  arrow_left as IMG_ARROW_LEFT,
  arrow_right as IMG_ARROW_RIGHT,
  back_top as IMG_BACK_TOP,
  lock_icon as IMG_LOCK_ICON,
  company_icon as IMG_COMPANY_ICON,
  rank_bg as IMG_RANK_BG,
  tip_arrow_top as IMG_TIP_ARROW_TOP,
  company_ceo_icon as IMG_COMPANY_CEO_ICON,
  company_income_icon as IMG_COMPANY_INCOME_ICON,
  company_member_icon as IMG_COMPANY_MEMBER_ICON,
  company_product_icon as IMG_COMPANY_PRODUCT_ICON,
  company_update_icon as IMG_COMPANY_UPDATE_ICON,
  more_left_arrow as IMG_MORE_LEFT_ARROW,
  more_right_arrow as IMG_MORE_RIGHT_ARROW,
  invite_icon as IMG_INVITE_ICON,
  question_add as IMG_QUESTION_ADD,
  question_photo as IMG_QUESTION_PHOTO,
  question_select as IMG_QUESTION_SELECT,
  question_sub as IMG_QUESTION_SUB,
  question_unselect as IMG_QUESTION_UNSELECT,
  question_wrong as IMG_QUESTION_WRONG,
  question_alert as IMG_QUESTION_ALERT,
  question_close as IMG_QUESTION_CLOSE,
  ad as IMG_BANNER,
  search as IMG_SEARCH,
  eye as IMG_EYE,
  scratch_icon as IMG_SCRATCH_ICON,
  left_arrow_orange as IMG_ARROW_ORANGE_LEFT,
  right_arrow_orange as IMG_ARROW_ORANGE_RIGHT,
  user_guide_arrow as IMG_USER_GUIDE_ARROW,
  default_avatar as IMG_DEFAULT_AVATAR,
  scratch_all_works as IMG_SCRATCH_ALL_WORKS,
  lock_schedule as IMG_LOCK_SCHEDULE,
  activity_signup as IMG_ACTIVITY_SIGNUP,
  activity_logo as IMG_ACTIVITY_LOGO,
  disney_activity as IMG_DISNEY_ACTIVITY
}
